// API Configuration
// Use environment variable if available, otherwise default to localhost:3001
 const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
// const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';
export default API_BASE_URL;
